<div>
  <div>
    <span class="info-label">Is booking required for members?</span>
    {{ getBookingType() }}
  </div>
  @if (externalBookingInfo.channel.email) {
    <div>
      <span class="info-label">Booking email:</span>
      {{ externalBookingInfo.channel.email }}
    </div>
  }
  @if (externalBookingInfo.channel.phone) {
    <div>
      <span class="info-label">Booking phone number:</span>
      {{ externalBookingInfo.channel.phone }}
    </div>
  }
  @if (externalBookingInfo.channel.link) {
    <div>
      <span class="info-label">Booking link:</span>
      {{ externalBookingInfo.channel.link }}
    </div>
  }
</div>
